import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const baseUrl = '/secure/policies/teams'

export const teamsApi = createApi({
  reducerPath: 'teamsPolicies',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getTeamsPolicies: builder.query({
      query: ({ configType, customerId }) => ({
        url: `${baseUrl}/${configType}`,
        params: { customerId },
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
    }),
    getTeamsPolicy: builder.query({
      query: ({ configType, customerId, identity }) => ({
        url: `${baseUrl}/${configType}`,
        params: { customerId, identity },
      }),
    }),
    createTeamsPolicy: builder.mutation({
      query: ({ configType, customerId, payload }) => ({
        url: `${baseUrl}/${configType}`,
        method: 'POST',
        params: { customerId },
        body: payload,
      }),
    }),
    updateTeamsPolicy: builder.mutation({
      query: ({ configType, customerId, identity, payload }) => ({
        url: `${baseUrl}/${configType}`,
        method: 'PUT',
        params: { customerId, identity },
        body: payload,
      }),
    }),
    deleteTeamsPolicy: builder.mutation({
      query: ({ configType, customerId, identity }) => ({
        url: `${baseUrl}/${configType}`,
        method: 'DELETE',
        params: { customerId, identity },
      }),
    }),
  }),
})

export const {
  useGetTeamsPoliciesQuery,
  useLazyGetTeamsPoliciesQuery,
  useGetTeamsPolicyQuery,
  useLazyGetTeamsPolicyQuery,
  useCreateTeamsPolicyMutation,
  useUpdateTeamsPolicyMutation,
  useDeleteTeamsPolicyMutation,
} = teamsApi

export const useGetCustomerTeamsPolicies = (configType, queryOptions = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetTeamsPoliciesQuery(
    { configType, customerId },
    {
      ...queryOptions,
      skip: Boolean(queryOptions.skip) || !customerId || !configType,
    },
  )
}

export const useGetCustomerTeamsPolicy = ({ configType, identity }, queryOptions = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetTeamsPolicyQuery(
    { configType, customerId, identity },
    {
      ...queryOptions,
      skip: Boolean(queryOptions.skip) || !customerId || !configType || !identity,
    },
  )
}
